import { render, staticRenderFns } from "./FirmAssociationDocuments.vue?vue&type=template&id=008b2992"
import script from "./FirmAssociationDocuments.vue?vue&type=script&lang=js"
export * from "./FirmAssociationDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports